import _ from "lodash";
import { DaysOfWeek, IFilterResponse, IFilterViewModel, IOptionResponse } from "@/models/filter.model";
import { ObjectionCategory } from "@/models/shared.model";
import { Sentiment } from "@/models/sentiment.model";
import { API_ROUTES } from "@/constants/apiRoutes";
import { SHORT_CALLS_OPTIONS } from "@/constants/filter";
import { httpRequestServer } from "@/services/httpRequestServer";

export const filtersDataService = {
  getFiltersAsync: async () : Promise<IFilterViewModel> => {
    const response: IFilterResponse = await httpRequestServer.get(`${API_ROUTES.FILTERS}/get`);
    return transformFilterResponseToViewModel(response);
  }
};

const transformFilterResponseToViewModel = (data: IFilterResponse) : IFilterViewModel => {
  function mapSentiments(sentiment: typeof Sentiment) {
    return Object.keys(sentiment).map((key, index) => {
      const keyItem = sentiment[key as keyof typeof Sentiment];
      return {
        name: keyItem as string,
        value: keyItem,
        sequence: index,
      };
    });
  }
  let { minDuration, maxDuration } = getMinMaxDuration(data.callDurations);
  return {
    campaigns: data.campaigns,
    teams: data.teams,
    queues: data.queues,
    users: data.users,
    resultCodes: data.resultCodes.map(item => {
      return {
        name: item.name ? `${item.value} - ${item.name}` : item.value,
        value: item.value
      };
    }),
    callDirections: data.callDirections,
    lists: data.lists.map(item => (
      {
        name: item.name,
        value: item.value?.replace(/\s/g, '_')
      })
    ),
    shortCalls: _.cloneDeep(SHORT_CALLS_OPTIONS),
    daysOfWeek: Object.keys(DaysOfWeek).map((key, index) => { 
      const keyItem = DaysOfWeek[key as keyof typeof DaysOfWeek];
      return { 
        name: keyItem as string, 
        value: keyItem,
        sequence: index
      };
     }),
    minDuration: minDuration,
    maxDuration: maxDuration,
    topics: data.topics.map(item => (
      {
        name: item.name,
        value: item.value?.replace(/\s/g, '_')
      })
    ),
    overallSentiments: mapSentiments(Sentiment),
     peakSentiments: mapSentiments(Sentiment),
     endSentiments: mapSentiments(Sentiment),
     objections: Object.keys(ObjectionCategory).map((key, index) => {
      const keyItem = ObjectionCategory[key as keyof typeof ObjectionCategory];
      return {
        name: keyItem as string,
        value: keyItem,
        sequence: index,
        childItems: data.objections.filter(item => item.value.category === keyItem).map(item => {
          return {
            name: item.name,
            value: item.name?.replace(/\s/g, '_')
          }
        }),      
      }
     }),
    dataSuppliers: data.dataSuppliers,
    scorecards: (data.scorecards ?? []).map(item => ({
      name: item.name,
      value: item.value
    })),
  };
};

const getMinMaxDuration = (durations: IOptionResponse<string>[]) => {
  let durationValues = durations[0]?.value.split("-").map(stringValue => parseInt(stringValue));
  return {
    minDuration: durationValues?.[0],
    maxDuration: durationValues?.[1]
  };
};